export const GET_PACKING_TYPES = "GET_PACKING_TYPES";
export const GET_PACKING_TYPE = "GET_PACKING_TYPE";
export const ADD_PACKING_TYPE = "ADD_PACKING_TYPE";
export const DELETE_PACKING_TYPE = "DELETE_PACKING_TYPE";
export const UPDATE_PACKING_TYPE = "UPDATE_PACKING_TYPE";
